var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    attrs: {
      "id": "calendar"
    }
  }), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-box"
  }, [_c('h5', [_vm._v("Edit Event")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editEventTitle),
      expression: "editEventTitle"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "Judul Event Baru"
    },
    domProps: {
      "value": (_vm.editEventTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editEventTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteEvent
    }
  }, [_vm._v("Hapus")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.updateEvent
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Batal\n          ")])])])]) : _vm._e()]), _vm._v(" "), (_vm.showAddModal) ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-box"
  }, [_c('h5', [_vm._v("Tambah Event")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEvent.title),
      expression: "newEvent.title"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "Judul Event"
    },
    domProps: {
      "value": (_vm.newEvent.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEvent, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "13px",
      "color": "#666"
    }
  }, [_vm._v("\n        Tanggal: " + _vm._s(_vm.newEvent.start) + " s/d " + _vm._s(_vm.newEvent.end) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveEvent
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": _vm.cancelAdd
    }
  }, [_vm._v("Batal")])])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4751f658","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Kalender/Calender.vue
// module id = JtIx
// module chunks = 1